/**
 * @generated SignedSource<<4212ddcef597d56671cc3f0fe7f5f434>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AppDialogTextTypePreviewItem_appDialog$data = {
  readonly appDialogBody: string | null;
  readonly appDialogButton: string | null;
  readonly appDialogTitle: string | null;
  readonly " $fragmentType": "AppDialogTextTypePreviewItem_appDialog";
};
export type AppDialogTextTypePreviewItem_appDialog$key = {
  readonly " $data"?: AppDialogTextTypePreviewItem_appDialog$data;
  readonly " $fragmentSpreads": FragmentRefs<"AppDialogTextTypePreviewItem_appDialog">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AppDialogTextTypePreviewItem_appDialog",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "appDialogTitle",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "appDialogBody",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "appDialogButton",
      "storageKey": null
    }
  ],
  "type": "AppDialog",
  "abstractKey": null
};

(node as any).hash = "c2d81a17c95ab99a7bd61cafab6a2de3";

export default node;
